export default "__VITE_ASSET__CjAlMK0L__"